import React from 'react';
import './sec1-booking.css'
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import Cta from '../components/common/cta';
import { useNavigate } from 'react-router-dom';
import Inputtext from '../components/common/input';
import Inputselect from '../components/common/input-select';
import Ticketnum from '../components/common/ticketnumb';
import Textarea from '../components/common/textarea';
import { useLocation } from 'react-router-dom';
import Errormsginput from '../components/common/errormsginput';
import Popup from '../components/common/popup';
const Sec1booking = () => {


const location = useLocation();

const [bookingData, setBookingData] = useState(
  location.state || {
    ticket: null,
    quantity: 1,
    user: { name: "", email: "", phone: "", job_title: "", company_name: "", address: "" },
   date: null,  
  }
);


 const [content, setcontent]= useState([]);
      useEffect(() => {
      const getcontent = async()=>{
          const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;
    
      setcontent(res.data);
      }
      getcontent();
      }, []);





const [dates, setDates]= useState([]);



useEffect(() => {
  const getDates = async () => {
    const res = await supabase
      .from("exbition_event")
      .select("id, start_date, end_date, status")
      .eq("status", "ongoing")
      .limit(1);

    const event = res.data?.[0];

    if (!event) return;

    setBookingData(prev => ({
      ...prev,
      eventId: event.id
    }));

    const start = new Date(event.start_date);
    const end = new Date(event.end_date);

    const daysArray = Array.from(
      { length: Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1 },
      (_, i) => {
        const date = new Date(start);
        date.setDate(start.getDate() + i);
        return date;
      }
    );

    setDates(daysArray);
  };

  getDates();
}, []);




const [ticket, setticket]= useState([]);
      useEffect(() => {
      const getcontent = async()=>{
          const res = await supabase.from('ticket').select('*').order('id', { ascending: true });;;
    
      setticket(res.data);
      }
      getcontent();
      }, []);




const navigate = useNavigate();


      const [showErrorPopup, setShowErrorPopup] = useState(false);
      const [popup, setPopup] = useState([]);

      useEffect(() => {
        const getpopup = async () => {
          const res = await supabase.from('Popup_content').select('*').order('id', { ascending: true });
          setPopup(res.data);
        };
        getpopup();
      }, []);


            const [ticketError, setTicketError] = useState("");
            const [nameError, setNameError] = useState("");
            const [emailError, setEmailError] = useState("");
            const [dateError, setDateError] = useState("");
            const [phoneError, setPhoneError] = useState("");




            const handleNext = () => {
              let hasError = false;

              if (!bookingData.ticket) { setTicketError("Please select a ticket type"); hasError = true; }
              else setTicketError("");


                if (!bookingData.user.name) { setNameError("Name is required"); hasError = true; }
                else setNameError("");

              if (!bookingData.user.email) { setEmailError("Email is required"); hasError = true; } else if (!/\S+@\S+\.\S+/.test(bookingData.user.email))
                { setEmailError("Invalid email format"); hasError = true; }
              else setEmailError("");

                if (!bookingData.date) { setDateError("Please select a date"); hasError = true; }
                else setDateError("");

              if (!bookingData.user.phone) { setPhoneError("Phone is required"); hasError = true; } else setPhoneError("");

                if (hasError) {
                  setShowErrorPopup(true);
                  return; }

              navigate('/booking-summary', { state: bookingData });
            };



    return (  
    <section  className='sec1-booking '>
            <h1 className='header-section'>{content?.[30]?.header}</h1>
            <nav className='container-booking-points'>
                <nav className='line-points-booking'>
                  <button className='activecircle'></button>                                     
                  <button className='normal-circle' onClick={handleNext}></button>                  
                  <button className='normal-circle' onClick={handleNext}></button> 
                </nav>
            </nav>


<fieldset className='container-forms-booking'>
            <form className='form-booking'>
                <h2 className='subheadr-booking'>{content?.[30]?.sub_title}</h2>
                <fieldset className='container-inputs-form-booking'>
                    <Inputselect 
                    label="Select Ticket Type"
                    placeholder="Select ticket"
                    value={bookingData.ticket}
                    options={ticket}
                    onChange={(selectedTicket) =>
                        setBookingData(prev => ({
                        ...prev,
                        ticket: selectedTicket
                        }))
                    }
                    />
                      <Errormsginput message={ticketError} />

                         <Ticketnum  title='Number of Tickets'
                          value={bookingData.quantity}
                          onChange={(value) =>
                            setBookingData(prev => ({
                              ...prev,
                              quantity: value
                            }))
                          }
                        />
                </fieldset>
            </form>


            <form className='form-booking'>
                <h2 className='subheadr-booking'>{content?.[30]?.sub_title2}</h2>
                <fieldset className='container-inputs-form-booking'>
                    <Inputtext id='full name'  label='Full Name' placeholder='Enter your name'
                    value={bookingData.user.name}
                             onChange={(e) =>
                                      setBookingData(prev => ({
                                        ...prev,
                                        user: {
                                          ...prev.user,
                                          name: e.target.value
                                        }
                                      }))
                                    }/>
                      <Errormsginput message={nameError} />
                    <Inputtext id='Email Address'  label='Email Address' placeholder='Enter your email'
                     value={bookingData.user.email}
                     onChange={(e) =>
                                        setBookingData(prev => ({
                                          ...prev,
                                          user: {
                                            ...prev.user,
                                            email: e.target.value
                                          }
                                        }))
                                      }/>
                            <Errormsginput message={emailError} />
                        <Inputselect 
                        label="Select Event Date"
                        placeholder="Select date"
                        options={dates.map(date => date.toDateString())}
                        value={bookingData.date ? new Date(bookingData.date).toDateString() : ""}
                        onChange={(selectedDate) =>
                            setBookingData(prev => ({
                            ...prev,
                            date: new Date(selectedDate)
                            }))
                        }
                        />
                        <Errormsginput message={dateError} />


                         <Inputtext id='phone number'  label='Phone Number' placeholder='Enter your phone number'
                         value={bookingData.user.phone}
                         onChange={(e) =>
                                      setBookingData(prev => ({
                                        ...prev,
                                        user: {
                                          ...prev.user,
                                          phone: e.target.value
                                        }
                                      }))
                                    }/>
                          <Errormsginput message={phoneError} />



                         <Inputtext id='Job Title'  label='Job Title' placeholder='Enter your job title'
                         value={bookingData.user.job_title}
                          onChange={(e) =>
                                    setBookingData(prev => ({
                                      ...prev,
                                      user: {
                                        ...prev.user,
                                        job_title: e.target.value
                                      }
                                    }))
                                  }/>


                         <Inputtext id='Company / organization '  label='Company / organization '
                          placeholder='Enter your company name'
                          value={bookingData.user.company_name}
                          onChange={(e) =>
                                    setBookingData(prev => ({
                                      ...prev,
                                      user: {
                                        ...prev.user,
                                        company_name: e.target.value
                                      }
                                    }))
                                  }/>

                         <Textarea id='Address'  label='Address' placeholder='Enter your address'
                          value={bookingData.user.address}
                         onChange={(e) =>
                                        setBookingData(prev => ({
                                          ...prev,
                                          user: {
                                            ...prev.user,
                                            address: e.target.value
                                          }
                                        }))
                                      }/>
                </fieldset>
            </form>

    </fieldset>

            <Cta
            title={content?.[30]?.cta} onClick={handleNext}/>

             {showErrorPopup && (
              <Popup
                to="/booking"
                onClose={() => setShowErrorPopup(false)}
                img={popup?.[3]?.image}
                alt={popup?.[3]?.icon_alt}
                header={popup?.[3]?.title}
                para={popup?.[3]?.paragraph}
                title={popup?.[3]?.cta_text_primary}
              />
            )}


    </section>);
}
 
export default Sec1booking;